import router from '@/router';
import api from '@/api';

export default {
  namespaced: true,
  state     : {
    basket      : [],
    count       : null,
    error       : {},
    error_basket: [],
  },
  getters: {
    basket      : ({basket}) => basket,
    count       : ({count}) => count,
    error       : ({error}) => error,
    error_basket: ({error_basket}) => error_basket,
  },
  mutations: {
    SET_BASKET(state, value) {
      state.basket = value;
      if (value) {
        value.PRODUCTS ? state.error_basket = value.PRODUCTS.filter((item) => {
          return item.ACTIVE !== true || item.REMAINDER - item.QUANTITY < 0;
        }) : [];
        state.count = value.QUANTITY;
      } else {
        state.count = 0;
        state.basket = [];
      }
    },
    SET_ERROR(state, value) {
      state.error = value;
    },
  },
  actions: {
    async getBasket({commit}, id) {
      try {
        const get_basket = await api.prize_shop.get_basket(id);
        localStorage.setItem('basket', JSON.stringify(get_basket.data.data.ID));
        commit('SET_BASKET', get_basket.data.data);
        commit('SET_ERROR', {id: null, message: null});
      } catch (err) {
        console.error(err);
      }
    },
    async addBasket({commit}, value) {
      try {
        const id = localStorage.getItem('basket');
        const add_basket = id ? await api.prize_shop.add_basket(value, id) : await api.prize_shop.add_basket(value);
        localStorage.setItem('basket', JSON.stringify(add_basket.data.id));
        const actual_id = add_basket.data.id;
        const get_basket = await api.prize_shop.get_basket(actual_id);
        commit('SET_BASKET', get_basket.data.data);
      } catch (err) {
        console.error(err);
      }
    },
    async delete_item({commit}, value) {
      try {
        let id = localStorage.getItem('basket');
        const delete_item = await api.prize_shop.delete_item(value, id);
        id = delete_item.data.id;
        localStorage.setItem('basket', JSON.stringify(id));
        const get_basket = await api.prize_shop.get_basket(id);
        commit('SET_BASKET', get_basket.data.data);
      } catch (err) {
        console.error(err);
      }
    },
    async set_order({commit}, value) {
      try {
        const set_order = await api.prize_shop.set_order(value);
        localStorage.setItem('basket', JSON.stringify(0));
        router.push('/prize_successful_order');
        const get_user_points = await api.user.get_user_points();
        console.log(get_user_points.data);
        commit('profile/user/SPEND_POINTS', get_user_points.data, {root: true});
        commit('SET_BASKET', []);
      } catch (err) {
        console.error(err);
      }
    },
  },
};
